import { attr } from '@ember-data/model';
import { array, fragment } from 'ember-data-model-fragments/attributes';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import Enum from '@square/dashboard-utilities/utils/enum';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import UsageRule from '@square/dashboard-data/models/squareup/sub2/usage-rule';
export const BillingCycle = new Enum(['UNKNOWN', 'PREPAY_MONTHLY', 'FREE', 'PAY_AS_YOU_GO_MONTHLY', 'PAY_AS_YOU_GO', 'POSTPAY_MONTHLY', 'ONE_TIME', 'PREPAY_YEARLY']);
export const UnavailableReasonCode = new Enum(['MAX_USAGE']);
export const UnavailableReason = EmberDataBaseFragment.extend({
  code: attr('enum', {
    enumClass: UnavailableReasonCode
  }),
  details: attr('string')
});
export default EmberDataBaseModel.extend({
  token: attr('string'),
  name: attr('string'),
  description: attr('string'),
  free: attr('boolean'),
  available: attr('boolean'),
  usageRules: array(UsageRule),
  unavailableReason: fragment(UnavailableReason),
  renewalCycle: fragment('squareup/sub2/duration-ed'),
  billingCycle: attr('enum', {
    enumClass: BillingCycle
  }),
  estimatedCost: attr('money-proto')
});